export const COPY_CONTAINER_STYLE =
    'font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 1.45; color: #222222; background: #ffffff;';
export const COPY_HEADING_STYLE =
    'font-family: Arial, Helvetica, sans-serif; font-size: 16px; font-weight: 700; color: #111111; margin: 16px 0 8px;';
export const COPY_TABLE_STYLE = 'border-collapse: collapse; border: 1px solid #cccccc; width: 100%;';
export const COPY_CELL_STYLE = 'border: 1px solid #cccccc; padding: 6px 10px; text-align: left; vertical-align: top;';
export const COPY_TH_STYLE = COPY_CELL_STYLE + ' background: #f2f2f2; font-weight: 700;';

export const COPY_SOURCE_ID = 'ssb-strategy-copy-source';
export const COPY_SOURCE_STYLE =
    'position: fixed; left: -100000px; top: 0; width: 800px; background: #ffffff; color: #222222;';

export const COPY_TRIGGER_CLASS = 'StrategyCopyButton';

export const STRIPPED_ATTRIBUTES: string[] = ['class', 'id', 'style'];
export const STRIPPED_TAGS: string[] = ['script', 'style', 'button', 'noscript', 'object', 'embed', 'iframe', 'form', 'base', 'link', 'meta'];
export const URL_ATTRIBUTES: string[] = ['href', 'src', 'data', 'xlink:href', 'formaction', 'poster'];
export const STRIPPED_URL_SCHEMES: string[] = ['javascript', 'data', 'vbscript'];
